import styled from 'styled-components';
import { DefaultWidgetBorder } from '../styles/BordersStyle';
import ColorConstants from '../../constants/ColorConstants';
import { getZIndexByLayerName, LayerNames } from '../../constants/layers.constants';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import { FlexDiv } from '../base/Div';


const DropDownContainer = styled(FlexDiv)`
    ${DefaultWidgetBorder};
    background-color: ${ColorConstants.white};
    border-radius: 30px 0px 30px 30px;
    flex-direction: column;
    height: auto;
    margin-top: 20px;
    overflow: hidden;
    padding-bottom: 20px;
    position: absolute;
    right: 0px;
    width: ${({ width = '330px' }) => width};
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_1000)};


    @media ${MobileScreen} {
        width: 95vw;
    }
    
    -webkit-box-shadow: 3px 5px 10px -1px rgba(209,215,219,0.87);
    -moz-box-shadow: 3px 5px 10px -1px rgba(209,215,219,0.87);
    box-shadow: 3px 5px 10px -1px rgba(209,215,219,0.87);
    
    ${({ styles }) => styles && { ...styles }};
`;

export default DropDownContainer;
